import { queries } from "lib/build/dashboards/htx/queries";
import { Status } from "lib/build/forms/htx/patientCondition";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useLastEventValueByQuery } from "src/features/events";
import { longStatusMessages } from "src/modules/htx/messages";

export function useLongStatus(): string | undefined {
	const formatMessage = useFormatMessageMap();
	const status =
		useLastEventValueByQuery<Status>(queries.patientStatus) || Status.NEW;
	return formatMessage(longStatusMessages, status);
}
